module.exports = require("core-js/library/fn/is-iterable");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/is-iterable.js
// module id = 63
// module chunks = 35783957827783 153662236231701 175947910196865